<template>
  <div class="vue timparty-instantwin-card instantwin-card" :id="'instant-win-card-' + contest.id">
    <div :class="'card card-contest '">
      <a v-if="contest.extra && contest.extra.url" :href="contest.extra.url" @click="statsClick(contest)">
<!--          <div class="card-img-top bg-cover" :style="card_image != undefined ? 'background-image: url(' + card_image + ')' : ''">-->
        <div class="card-img-top bg-cover" :data-bg="card_image != undefined ? card_image : null ">
          <countdown v-if="countdown.time" class="instant-win-countdown" :ts-end="countdown.time"
                     :heading="countdown.label"></countdown>
          <div class="instant-win-ended-info" v-else>
            <p class="font-weight-bold">Concorso terminato</p>
            <p class="small" v-if="participationStatus">{{ participationStatus }}</p>
          </div>
        </div>
      </a>
<!--        <div v-else  class="card-img-top bg-cover" :style="card_image != undefined ? 'background-image: url(' + card_image + ')' : ''">-->
      <div v-else class="card-img-top bg-cover" :data-bg="card_image != undefined ? card_image : null ">
        <countdown v-if="countdown.time" class="instant-win-countdown" :ts-end="countdown.time"
                   :heading="countdown.label"></countdown>
        <div class="instant-win-ended-info" v-else>
          <p class="font-weight-bold">Concorso terminato</p>
          <p class="small" v-if="participationStatus">{{ participationStatus }}</p>
        </div>
      </div>
      <div class="card-body text-left p-3">
        <div class="badge badge-accent">{{ contest.name }}</div>
        <badge-counter label-text="Partecipa e ottieni" :badge-count="contest.badgeAvailable" :hide-info="true"
                       v-if="!contest.extra.hide_badges"></badge-counter>
        <h3 class="mt-1" v-html="contest.title"></h3>
        <div class="contest-description" v-html="contest.description"></div>
      </div>
      <div class="card-footer d-flex align-items-end p-3" :class="{'vincitori-footer' : contestType}">
        <a href="#" v-if="contestType" @click="showWinners"
           class="font-weight-bold btn text-primary btn-lg btn-block btn-secondary vincitori-btn "
           :class="isEndedPartyCollExtraction ? 'invisible' : ''">{{ __('SCOPRI I VINCITORI') }} &nbsp;&gt;</a>
        <a v-if="contest.extra && contest.extra.url" @click="statsClick(contest)" :href="contest.extra.url"
           class="btn btn-primary btn-lg btn-block">{{ __('SCOPRI DI PIÙ') }}</a>
      </div>
    </div>

    <basic-modal :modal-id="modal_id" modal-class="modal-md" :contest-id="contest.id"
                 :id="'modal-acceptance-' + contest.id" class="modal-acceptance" :show="modal.show"
                 v-on:modalClose="modal.show = false">
      <div v-if="modal.state == 'winners'">
        <div class="modal-body text-center p-5">

          <div v-if="winners.length > 0">
            <h4>{{ __('Ecco i vincitori del concorso') }}</h4>
            <list-winners :winners="winners"></list-winners>
          </div>
          <div v-else>
            <p>Nessun vincitore trovato</p>
          </div>

          <button @click.prevent="modal.show = false" class="btn btn-primary btn-lg">{{ __('CHIUDI') }}</button>


        </div>
      </div>
    </basic-modal>

    <ErrorModal :error="error" v-on:modalClose="error = null"/>

  </div>
</template>

<script>

/* eslint-disable */


import {isNull, isUndefined} from "lodash";
import TimPartyMixin         from '../mixins/TimPartyMixin';
import Countdown     from './Countdown.vue';
import BadgeCounter  from './BadgeCounter.vue';
import BasicModal    from "./BasicModal";
import ErrorModal    from "./ErrorModal";
import ListWinners   from "./ListWinners";
import $             from "jquery";
import moment        from "moment";

export default {
  name: 'InstantWinCard',
  mixins: [TimPartyMixin],
  components: {
    Countdown,
    BadgeCounter,
    BasicModal,
    ErrorModal,
    ListWinners
  },
  props: {
    contest: {
      type: Object,
      required: true
    },
    contestType: {
      type: String,
      required: false
    },
    apiUrl: {
      type: String,
      required: false
    }

  },
  data: function () {

    return {
      modal: {
        id: 'modal-iw-basic',
        show: false,
        class_name: 'modal-lg',
        error: null,
        state: null
      },
      winners: []
    };
  },
  mounted: function () {
    var self = this;

    this.setApiUrl(this.apiUrl);

    // Seleziona tutti gli elementi della Carousel che hanno l'attributo data-bg
    const lazyBgItems = document.querySelectorAll('.card-img-top[data-bg]');

    // Configura l'osservatore per controllare quando gli elementi entrano nell'area visibile
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.backgroundImage = `url('${entry.target.dataset.bg}')`;
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px', threshold: 0.1 });

    // Aggiungi tutti gli elementi alla lista di osservazione
    lazyBgItems.forEach(item => {
      observer.observe(item);
    });
  },
  methods: {
    statsClick: function (contest) {
      this.gtmEvent({
        event: 'giocaEvinciClick',
        eventCategory: 'Click',
        eventAction: 'Gioca e Vinci',
        eventLabel: contest.title
      });

      this.aaEvent('click', {
        form: {
          banner: 'carousel gioca-' + this.stripTags(contest.title)
        }
      });
    },
    showWinners: function () {
      var self = this;

      var payload = {
        action: 'getWinners',
        access_token: this.access_token,
        contest_code: this.contest.code
      };

      this.loading    = true;
      self.modal.show = false;
      this.callApi(payload, function (response) {
        self.loading = false;

        if (!response.success) {
          self.showError(response.data);
        }
        else if (response.data != undefined) {
          self.winners     = response.data;
          self.modal.state = 'winners';
          self.modal.show  = true;
          $('#modal-acceptance-' + self.contest.id).appendTo('body');
        }
      });
    }
  },
  computed: {
    card_image: function () {

      let card_image;
      let base_path_images = isUndefined(this.user.base_path_images) || isNull(this.user.base_path_images) ? '' : this.user.base_path_images;
      if (_.has(this.contest, 'extra.images.slider')) {
        card_image = this.contest.extra.images.slider[0];
        card_image = !isNull(card_image) ? base_path_images + card_image : null;
      }
      else if (_.has(this.contest, 'extra.images.featured')) {
        card_image = this.contest.extra.images.featured[0];
        card_image = !isNull(card_image) ? base_path_images + card_image : null;
      } else {
        card_image = [];
      }
      return card_image;

    },

    countdown_label: function () {
      var label = null;
      var now   = Math.floor(new Date().getTime() / 1000);

      if (this.contest.startDate != undefined && now < this.contest.startDate) {
        label = this.__('MANCANO SOLO');
      }
      else if (this.contest.endDate != undefined && now < this.contest.endDate) {
        label = this.__('SCADE TRA');
      }

      return label;
    },

    countdown_time: function () {

      var time = null;
      var now  = Math.floor(new Date().getTime() / 1000);

      if (this.contest.startDate != undefined && now < this.contest.startDate) {
        time = this.contest.startDate;
      }
      else if (this.contest.endDate != undefined && now < this.contest.endDate) {
        time = this.contest.endDate;
      }

      return time;

    },

    countdown: function () {

      var now = Math.floor(new Date().getTime() / 1000);

      var result = {
        label: '',
        time: null
      };

      if (this.contest) {

        if (this.contest.startDate != undefined && now < this.contest.startDate) {
          result.label = this.__('MANCANO SOLO');
          result.time  = this.contest.startDate;
        }
        else if (this.contest.endDate != undefined && now < this.contest.endDate) {
          result.label = this.__('SCADE TRA');
          result.time  = this.contest.endDate;
        }
      }

      return result;

    },


    participationStatus: function () {
      var result = '';

      return result;

      if (!this.contest.numUserPlayed) {
        result = 'Non hai partecipato';
      }
      else if (this.contest.playResult != undefined) {
        if (this.contest.playResult.win) {
          result = 'Hai già partecipato e hai vinto!';
        }
        else {
          result = 'Hai già partecipato ma non hai vinto';
        }
      }


      return result;

    },
    isEndedPartyCollExtraction: function () {
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop)
      });

      let today = params.today ? moment(params.today, 'YYYYMMDDHHmmss') : moment();

      return this.contest.code == 'PARTY_COLL_6' && today > moment.unix(this.contest.endDate) && today < moment.unix(this.contest.finalExtractionDate);
    }
  }
}
</script>


